const Blockly = require('blockly');
// The default JavaScript code gen will try to put together statements
// from a 'Statement Input' block as code -- which makes sense.
// We need it to give us the content of a JSON with array instead
// with commas in between the 'statements'.
// This override of the default JavaScript scrub does what we need.
const originalScrub = Blockly.JavaScript.scrub_;
let reverseOrder = false;
const newScrub = function (block, code) {
    let nextBlock = block.nextConnection && block.nextConnection.targetBlock();
    let nextCode = Blockly.JavaScript.blockToCode(nextBlock);
    if (nextCode && nextCode.length > 0) {
        if (reverseOrder) {
            return nextCode + ',' + code;
        } else {
            return code + ',' + nextCode;
        }
    }
    return code + nextCode;
};

// Ability to switch is mainly used for testing.
const toExport = {
    revertToOriginal: function () {
        Blockly.JavaScript.scrub_ = originalScrub;
    },
    setToJsonScrub: function () {
        Blockly.JavaScript.scrub_ = newScrub;
    },
    setReverseOrder: function (reverse) {
        reverseOrder = reverse;
    }
};

// Default to JSON scrub.
toExport.setToJsonScrub();

module.exports = toExport;
